import { useGetUmbracoTafDeliveryApiV1ContentGetMenuSuspense } from '@shared/integrations/umbraco-taf-delivery-api/features/content/content.ts';
import MenuItem from './MenuItem';

const DynamicMenuItems = () => {
    const { data: menuItems } = useGetUmbracoTafDeliveryApiV1ContentGetMenuSuspense();
    return (
        <ul>
            {menuItems?.map((menuItem) => {
                return (
                    <li key={menuItem.url}>
                        <MenuItem item={menuItem} />
                    </li>
                );
            })}
        </ul>
    );
};
export default DynamicMenuItems;
